<template>
  <div class="content mb-5">
    <h2>{{ $t("Links") }}</h2>
    <b-row class="mb-6">
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="link"
          :label="this.$t('Support Desk URL')"
          :state="$validateState($v.form.link)"
        >
          <b-form-input
            id="link"
            data-test-id="support-support-desk-url"
            v-model="form.link"
            @blur="setValidationInput('link', $event.target.value)"
            :state="$validateState($v.form.link)"
            :placeholder="$t('Enter URL')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.link.minLength">
              {{ $t("Must contain at least 5 characters.") }}
            </p>
            <p v-if="!$v.form.link.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
            <p v-if="!$v.form.link.url">
              {{ $t("Please enter a valid URL") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
      <b-col sm="12" md="6" lg="6">
        <b-form-group
          v-if="!loading"
          class="mb-3"
          label-for="email"
          :label="this.$t('Contact')"
          :state="$validateState($v.form.email)"
        >
          <b-form-input
            id="email"
            data-test-id="support-email"
            v-model="form.email"
            @blur="setValidationInput('email', $event.target.value)"
            :state="$validateState($v.form.email)"
            :placeholder="$t('Enter email address')"
          />

          <template #invalid-feedback>
            <p v-if="!$v.form.email.minLength">
              {{ $t("Must contain at least 5 characters.") }}
            </p>
            <p v-if="!$v.form.email.maxLength">
              {{ $t("Must contain at most 200 characters.") }}
            </p>
            <p v-if="!$v.form.email.email">
              {{ $t("Please enter a valid email") }}
            </p>
          </template>
        </b-form-group>
        <b-skeleton
          v-if="loading"
          animation="wave"
          height="32px"
          width="100%"
        ></b-skeleton>
      </b-col>
    </b-row>
    <t-save-button
      data-test-id="support-save"
      :fetching="fetching"
      @submit="onSubmit"
      :form-model="$v.form"
    />
  </div>
</template>

<route>
{
  "name": "System Global Support"
}
</route>

<script>
import { mapActions, mapGetters } from "vuex";
import { minLength, maxLength, email, url } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      fetching: false,
      loading: true,
      form: {
        link: null,
        email: null,
      },
    };
  },
  methods: {
    ...mapActions("pageMeta", ["setPageTitle", "setPageSubtitle"]),
    ...mapActions("support", ["fetchSupport", "updateSupport"]),
    ...mapActions("toast", ["displayToast"]),
    setValidationInput(object, value) {
      this.form[`${object}`] = value;
      this.$v.form[`${object}`].$touch();
    },
    async onSubmit() {
      this.fetching = true;
      try {
        await this.updateSupport(this.form);
        this.displayToast({
          title: this.$t("Success"),
          message: this.$t("Your support links have been updated"),
          duration: 2000,
          variant: "success",
        });
      } finally {
        this.fetching = false;
      }
    },
  },
  computed: {
    ...mapGetters("authentication", ["selectedUser"]),
    ...mapGetters("support", ["support"]),
  },
  validations: {
    form: {
      link: {
        url,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
      email: {
        email,
        minLength: minLength(3),
        maxLength: maxLength(200),
      },
    },
  },
  watch: {
    customerPolicies() {
      this.policyOptions = [
        {
          value: null,
          text: this.$t("Select Policy"),
          disabled: true,
        },
        {
          value: "default",
          text: this.$t("Default Policy"),
        },
        ...this.customerPolicies.map((p) => {
          return { value: p.id, text: p.name };
        }),
      ];
    },
  },
  async created() {
    try {
      this.setPageTitle(this.$t("Support"));
      await this.fetchSupport();
      this.form = this.support;
    } finally {
      this.loading = false;
    }
  },
  mounted() {
    this.setPageSubtitle([
      this.$t(
        "Customize the links to your support services offered to your customers in their profile menu."
      ),
    ]);
  },
};
</script>
<style lang="scss" scoped>
div.invalid-feedback {
  position: relative;

  p {
    position: relative !important;
    margin: 0;
  }
}
</style>
